/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProgressStatus {

    NOT_STARTED = 'NOT_STARTED',

    IN_PROGRESS = 'IN_PROGRESS',

    COMPLETED = 'COMPLETED'
}

